<style scoped>
.margin-bottom {
  margin-bottom: 10px;
}
.margin-top {
  margin-top: 5px;
}
p, a {
  font-size: 13px;
}
</style>

<template>
  <app-layout class="emergency-hotline-template">
    <div style="padding:20px">
      <Card shadow>
        <div class="margin-bottom">
          <span style="font-size:14px"><b>EMERGENCY HOTLINE NUMBERS</b></span>
          <span v-for="(hotline) in emergencyHotline" :key="hotline.name">
            <p class="margin-top">{{hotline.name}}</p>
            <p v-for="(number) in hotline.numbers" :key="number.tel">
              <i><a :href="telNum(number.tel)">{{number.text}}</a></i>
            </p>
          </span>
          <!-- <p class="margin-top">Davao City Emergency Operations Center</p><p><i>CENTRAL <a href="tel:911">911</a></i></p>
          <p class="margin-top">Davao City Disaster Risk Reduction and Management Office (DRRMO)</p>
          <i><a href="tel:0822952387">(082) 295 2387</a></i>
          <p class="margin-top">PAGASA Davao Station</p><i><a href="tel:0822340890">(082) 234 0890</a></i>
          <p class="margin-top">Office of Civil Defense XI</p>
          <i><a href="tel:0822332022">(082) 233 2022</a> / <a href="tel:0822330611">(082) 233 0611</a></i> -->
        </div>
        <div class="margin-bottom">
          <span><b><u>SECURITY</u></b></span>
          <span v-for="(hotline) in securityHotline" :key="hotline.name">
            <p class="margin-top">{{hotline.name}}</p>
            <p v-for="(number) in hotline.numbers" :key="number.tel">
              <i><a :href="telNum(number.tel)">{{number.text}}</a></i>
            </p>
          </span>
          <!-- <p class="margin-top">Davao City Police Office</p>
          <i><a href="tel:0822241313">(082) 224 1313</a></i>
          <p><i>0925 823 3276 (TEXT)</i></p>
          <i><a href="tel:0822264521">(082) 226 4521</a></i>
          <i><a href="tel:117">117</a></i>
          <p class="margin-top">Davao City Public Safety and Security Guard Command Center (PSSCC)</p>
          <i><a href="tel:0822269370">(082) 226 9370</a> / <a href="tel:0822727400">(082) 272 7400</a></i>
          <p class="margin-top">Task Force Davao</p><i><a href="tel:0822240911">(082) 224 0911</a></i> -->
        </div>
        <div class="margin-bottom">
          <span><b><u>SOCIAL SERVICE</u></b></span>
          <span v-for="(hotline) in socialServiceHotline" :key="hotline.name">
            <p class="margin-top">{{hotline.name}}</p>
            <p v-for="(number) in hotline.numbers" :key="number.tel">
              <i><a :href="telNum(number.tel)">{{number.text}}</a></i>
            </p>
          </span>
          <!-- <p class="margin-top">Philippine Red Cross Davao Chapter</p>
          <i><a href="tel:0822276650">(082) 227 6650</a> / <a href="tel:143">143</a></i>
          <p class="margin-top">Department of Social Welfare and Development XI (DSWD)</p>
          <i><a href="tel:0822278746">(082) 227 8746</a></i>
          <p class="margin-top">Davao City Social Services and Development Office (CSSDO)</p>
          <i><a href="tel:0822250417">(082) 225 0417</a> / <a href="tel:0822271617">(082) 227 1617</a></i> -->
        </div>
        <div class="margin-bottom">
          <span><b><u>FIRE</u></b></span>
          <span v-for="(hotline) in fireHotline" :key="hotline.name">
            <p class="margin-top">{{hotline.name}}</p>
            <p v-for="(number) in hotline.numbers" :key="number.tel">
              <i><a :href="telNum(number.tel)">{{number.text}}</a></i>
            </p>
          </span>
          <!-- <p class="margin-top">Bureau of Fire Protection XI</p><i><a href="tel:0822216658">(082) 221 6658</a></i>
          <p class="margin-top">Davao Volunteer Fire Brigade</p><i><a href="tel:160">160</a></i> -->
        </div>
        <div class="margin-bottom">
          <span><b><u>UTILITY</u></b></span>
          <span v-for="(hotline) in utilityHotline" :key="hotline.name">
            <p class="margin-top">{{hotline.name}}</p>
            <p v-for="(number) in hotline.numbers" :key="number.tel">
              <i><a :href="telNum(number.tel)">{{number.text}}</a></i>
            </p>
          </span>
          <!-- <p class="margin-top">Davao Light and Power Company (DLPC)</p><i><a href="tel:0822293572">(082) 229 3572</a></i>
          <p class="margin-top">Davao City Water District (DCWD)</p><i><a href="tel:0822973293">(082) 297 3293</a></i> -->
        </div>
        <div class="margin-bottom">
          <span><b><u>TRAFFIC & TRANSPORT</u></b></span>
          <span v-for="(hotline) in trafficHotline" :key="hotline.name">
            <p class="margin-top">{{hotline.name}}</p>
            <p v-for="(number) in hotline.numbers" :key="number.tel">
              <i><a :href="telNum(number.tel)">{{number.text}}</a></i>
            </p>
          </span>
          <!-- <p class="margin-top">Department of Public Works and Highways XI</p>
          <i><a href="tel:0822269370">(082) 226 9370</a> / <a href="tel:0822727400">(082) 272 7400</a></i>
          <p class="margin-top">Philippine Coast Guard Region XI</p><i><a href="tel:0822350002">(082) 235 0002</a></i>
          <p><i>0921 743 9444</i></p>
          <p><i>0915 122 6712</i></p>
          <p class="margin-top">Davao City Transport and Traffic Management Office (CTTMO)</p><i><a href="tel:0822983602">(082) 298 3602</a></i> -->
        </div>
      </Card>
    </div>
  </app-layout>
</template>

<script>
import hotlines from '@/assets/emergency_hotline.json'
export default {
  name: 'EmergencyHotline',
  data() {
    return {
      emergencyHotline: hotlines.EMERGENCY_HOTLINE,
      securityHotline: hotlines.SECURITY,
      socialServiceHotline: hotlines.SOCIAL_SERVICE,
      fireHotline: hotlines.FIRE,
      utilityHotline: hotlines.UTILITY,
      trafficHotline: hotlines.TRAFFIC_TRANSPORT,
    }
  },
  methods: {
    telNum(num) {
      return "tel:" + num
    }
  }
}
</script>
